<template>
  <div>
    <v-fab-transition>
      <v-btn
        v-bind="$attrs"
        class="scanner-btn"
        :class="{ 'scanner-btn--shifted': shiftUp, 'scanner-btn--fixed': floating }"
        :large="floating"
        :fab="floating"
        color="primary"
        dark
        @click="qrCodeReaderShow = true"
      >
        <v-icon color="white">$vuetify.icons.qrCode</v-icon>
      </v-btn>
    </v-fab-transition>

    <v-dialog :value="qrCodeReaderShow" @click:outside="onClose">
      <v-card>
        <div v-if="qrCodeReaderShow" class="scanner-wrapper">
          <qrcode-stream @decode="onDecode" @init="onInit" />
        </div>

        <template v-if="result && isOrder">
          <p class="text-center">
            {{ $vuetify.lang.t('$vuetify.labels.orderFound') }}: <b>{{ result }}</b>
          </p>

          <v-btn class="w-100" height="50" color="primary" @click="_redirect">
            {{ $vuetify.lang.t('$vuetify.labels.goToOrder') }}
          </v-btn>
        </template>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  inheritAttrs: false,

  props: {
    floating: {
      type: Boolean,
      default: false,
    },
    isOrder: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      qrCodeReaderShow: false,
      result: '',
      error: '',
    };
  },

  computed: {
    shiftUp() {
      return !!this.$route.meta.scanButtonShift;
    },
  },

  watch: {
    error(val) {
      this.$alertError(val);
    },
  },

  methods: {
    onDecode(result) {
      this.result = result;

      if (!this.isOrder) {
        this.$emit('decode', result);
        this.qrCodeReaderShow = false;
      }
    },

    async onInit(promise) {
      try {
        await promise;
      } catch (error) {
        if (error.name === 'NotAllowedError') {
          this.error = this.$vuetify.lang.t('$vuetify.messages.cameraNotAllowedError');
        } else if (error.name === 'NotFoundError') {
          this.error = this.$vuetify.lang.t('$vuetify.messages.cameraNotFoundError');
        } else if (error.name === 'NotReadableError') {
          this.error = this.$vuetify.lang.t('$vuetify.messages.cameraNotReadableError');
        } else if (error.name === 'OverconstrainedError') {
          this.error = this.$vuetify.lang.t('$vuetify.messages.cameraOverconstrainedError');
        } else if (error.name === 'StreamApiNotSupportedError') {
          this.error = this.$vuetify.lang.t('$vuetify.messages.cameraStreamApiNotSupportedError');
        }
      }
    },

    onClose() {
      this.result = null;
      this.qrCodeReaderShow = false;
    },

    _redirect() {
      this.$router.push({ name: 'orders.detail', params: { id: this.result } });
      this.onClose();
    },
  },
};
</script>

<style>
.scanner-wrapper {
  height: 450px;
  padding: 15px;
}

.scanner-btn--shifted {
  margin-bottom: 92px;
}

.scanner-btn--fixed {
  margin: 0 16px 16px 0;
  bottom: 0;
  right: 0;
  position: fixed !important;
}
</style>
